import Reveal from "./Reveal";

const STEPS = [
  {
    n: "01",
    title: "Research",
    text: "We gather relevant business, trade and market information from credible sources.",
  },
  {
    n: "02",
    title: "Analyze",
    text: "We examine patterns, relationships and signals within the data.",
  },
  {
    n: "03",
    title: "Understand",
    text: "We interpret findings in the context of your market and objectives.",
  },
  {
    n: "04",
    title: "Grow",
    text: "We shape insight into practical direction for confident decisions.",
  },
];

export default function Approach() {
  return (
    <section id="approach" className="relative overflow-hidden bg-navy-900 py-24 md:py-32">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0">
        <div className="absolute -right-40 -top-40 h-[560px] w-[560px] rounded-full bg-[radial-gradient(circle,rgba(53,99,214,0.22),transparent_65%)]" />
        <div className="absolute -bottom-48 -left-32 h-[480px] w-[480px] rounded-full bg-[radial-gradient(circle,rgba(29,79,196,0.18),transparent_65%)]" />
      </div>

      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal className="max-w-2xl">
          <p className="eyebrow !text-navy-300">Our Approach</p>
          <h2 className="font-display text-3xl font-light leading-tight text-white sm:text-4xl lg:text-[2.75rem]">
            Research. Analyze. Understand. <span className="italic text-navy-300">Grow.</span>
          </h2>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-white/60 sm:text-lg">
            Our approach is research-driven by design. Every engagement begins
            with evidence — information is gathered with care, analysed
            rigorously and interpreted within the context of your market. The
            result is intelligence you can act on with confidence.
          </p>
        </Reveal>

        <div className="mt-16 grid gap-10 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8">
          {STEPS.map((s, i) => (
            <Reveal key={s.n} delay={0.1 * i}>
              <div
                data-testid={`approach-step-${i}`}
                className="border-t border-white/15 pt-6"
              >
                <span className="font-display text-3xl font-light text-navy-300">{s.n}</span>
                <h3 className="mt-3 text-sm font-semibold uppercase tracking-[0.18em] text-white">
                  {s.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-white/55">{s.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
